import { Flex } from '@chakra-ui/react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { DEFAULT_CURRENCY } from '../../constants';
import { Text } from '../../ui-components';
import type { TextSize } from '../../ui-components';

type Props = {
    id: string;
    price: number;
    currency?: string;
    color?: string;
    size?: TextSize;
};

export const SuggestedPrice: React.FC<Props> = ({
    id,
    currency = DEFAULT_CURRENCY,
    price,
    color = 'slt-black.600',
    size,
}: Props) => (
    <Flex data-testid={`${id}-product-suggested-price`} gap={1}>
        <Text id={`${id}-product-suggested-price-label`} style="regular" color={color} size={size}>
            <FormattedMessage id="suggested.price" defaultMessage="Sugg." />
        </Text>
        <Text
            id={`${id}-product-suggested-price-value`}
            style="regular"
            color={color}
            type="cross"
            size={size}
        >
            <FormattedNumber style="currency" currency={currency} value={price} />
        </Text>
    </Flex>
);

SuggestedPrice.defaultProps = {
    currency: DEFAULT_CURRENCY,
    color: 'slt-black.600',
    size: undefined,
};
